// Basic
import { useState } from 'react';
import PropTypes from 'prop-types';
// Components
import { Modal } from '@/common-utils/components/ui/modal';
import ContentConfirmActionMFA from './ContentConfirmActionMFA/ContentConfirmActionMFA';
import ContentSetMFA from './ContentSetMFA/ContentSetMFA';
import ContentRemoveMFA from './ContentRemoveMFA/ContentRemoveMFA';


/**
 * @param {boolean} isOpen
 * @param {function} setIsOpen
 * @returns {JSX.Element} ModalAskConfirmation Component
 */
function ModalSecureAccess({ isOpen, setIsOpen }) {
    // State
    const [isCancelClicked, setIsCancelClicked] = useState(false);
    const [showContentSetMFA, setShowContentSetMFA] = useState(false);
    const [showModalRemoveMFA, setShowModalRemoveMFA] = useState(false);
    const [showContentConfirmActionMFA, setShowContentConfirmActionMFA] = useState(true);

    const handleClose = () => {
        if (!isCancelClicked) {
            setIsCancelClicked(true);
        } else {
            setIsOpen(false);
        }
    };

    return (
        <Modal open={isOpen} onOpenChange={handleClose}>
            {
                showContentConfirmActionMFA &&
                <ContentConfirmActionMFA
                    onClose={handleClose}
                    showModalSetters={{ setShowContentConfirmActionMFA, setShowContentSetMFA, setShowModalRemoveMFA }}
                    isCancelClicked={isCancelClicked}
                />
            }
            {
                showContentSetMFA &&
                <ContentSetMFA
                    onClose={() => setIsOpen(false)}
                />
            }
            {
                showModalRemoveMFA &&
                <ContentRemoveMFA
                    onClose={() => setIsOpen(false)}
                />
            }
        </Modal>
    );
}

ModalSecureAccess.propTypes = {
    isOpen: PropTypes.bool,
    setIsOpen: PropTypes.func
};

export default ModalSecureAccess;